export const mutations = {
    setUnidadeMedida(state, data) {
        state.unidadeMedida = data
    },
    setUnidadesMedidas(state, data) {
        state.unidadesMedidas = data
    },
    addUnidadesMedida(state, data){
        state.unidadesMedidas.push(data)
    },
    removeUnidadesMedida(state, data){
        let index = state.unidadesMedidas.map(x => x.id).indexOf(data.id);
        state.unidadesMedidas.splice(index, 1)
    },
    setModalCadastrarUnidadeMedida(state, status) {
        state.modalCadastrarUnidadesMedida = status
    },
    setModalExcluirUnidadesMedida(state, status) {
        state.modalExcluirUnidadesMedida = status
    },
}

export default {}